import React from "react";
import { useTranslation } from "react-i18next";
import Popover from "@mui/material/Popover";
import { Link } from "react-router-dom";
import { INavMenuPopover } from "../types";
import { useStyles } from "../hooks/useStyles";
import { getFileName } from "helpers/GetFileNameFromDisposition";
import download from "downloadjs";
import { axiosApiInstance } from "app/axios";
import { getOnlyJwt } from "helpers/FetchHelper";
import { useNotification } from "shared/hooks";
//import { sendClientCommand } from "helpers/functions/clientCommand";
//import { useAsonikaSelector } from "app/redux/hooks";

export const NavMenuPopover = (props: INavMenuPopover) => {
  const [anchorElMyWork, setAnchorElMyWork] = React.useState(null);
  const { showNotify } = useNotification();
  const classes = useStyles();
  const { t } = useTranslation("shared");
  const open = Boolean(anchorElMyWork);
  const { headerNavTranslation, navLinksTranslation, idPopover, isDropButton } =
    props;
  //const user = useAsonikaSelector((store) => store.user);

  const onClickDownload = () => {
    //if (user.initClient) return sendClientCommand(`audits/download_logs`);
    axiosApiInstance
      .get("audits/DownloadLogs", {
        headers: getOnlyJwt(),
        responseType: "blob",
      })
      .then(async (response) => {
        const fileName = getFileName(
          response.headers["content-disposition"] ?? ""
        );
        download(response.data, fileName, response.headers["content-type"]);
      })
      .catch((error) => {
        showNotify(error.message, "error");
      });
  };
  return (
    <div
      onMouseEnter={(e: any) => setAnchorElMyWork(e.currentTarget)}
      onMouseLeave={() => setAnchorElMyWork(null)}
      style={{ display: "inline" }}
    >
      <button
        aria-haspopup="true"
        aria-owns={open ? idPopover : undefined}
        className={isDropButton ? classes.dropButton : classes.linkButton}
      >
        {t(`navmenu.${headerNavTranslation}` as any)}
      </button>
      <Popover
        id={idPopover}
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorElMyWork}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={() => setAnchorElMyWork(null)}
        disableRestoreFocus
      >
        {navLinksTranslation.map((linkT: any, i: any) =>
          linkT !== "downloadLogs" ? (
            <Link key={i} to={`/${linkT}`}>
              <button className={classes.dropButton}>
                {t(`navmenu.${linkT}` as any)}
              </button>
            </Link>
          ) : (
            <button onClick={onClickDownload} className={classes.dropButton}>
              {t(`navmenu.${linkT}` as any)}
            </button>
          )
        )}
      </Popover>
    </div>
  );
};
